const { registerBlockType } = wp.blocks;
const { InspectorControls, RichText } = wp.blockEditor;
const { PanelBody, SelectControl, Button, TextControl } = wp.components;
const { __ } = wp.i18n;
const { Fragment } = wp.element;

registerBlockType('pg/address-cards', {
  title: __('PG Address Cards'),
  icon: 'location-alt',
  category: 'layout',
  attributes: {
    sectionClass: {
      type: 'string',
      default: 'section-light-secondary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    addresses: {
      type: 'array',
      default: [],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      addresses,
    } = attributes;

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const onChangeCornerPositionClass = (newClass) => {
      setAttributes({ cornerPositionClass: newClass });
    };

    const onChangeCornerBackgroundClass = (newClass) => {
      setAttributes({ cornerBackgroundClass: newClass });
    };

    const addAddress = () => {
      const newAddresses = [...addresses, { title: '', address: '' }];
      setAttributes({ addresses: newAddresses });
    };

    const removeAddress = (index) => {
      const newAddresses = addresses.filter((_, i) => i !== index);
      setAttributes({ addresses: newAddresses });
    };

    const updateAddress = (index, field, value) => {
      const newAddresses = addresses.map((address, i) => {
        if (i === index) {
          return { ...address, [field]: value };
        }
        return address;
      });
      setAttributes({ addresses: newAddresses });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'None', value: 'corner-disabled' },
                { label: 'Left-Top', value: 'corner-left-top' },
                { label: 'Left-Bottom', value: 'corner-left-bottom' },
                { label: 'Right-Top', value: 'corner-right-top' },
                { label: 'Right-Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={onChangeCornerPositionClass}
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
                { label: 'Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'Light Secondary',
                  value: 'corner-on-light-secondary',
                },
              ]}
              onChange={onChangeCornerBackgroundClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div
            className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
          ></div>
          <div className="section-wrapper">
            <div className="offices-list">
              {addresses.map((address, index) => (
                <div className="address-card" key={index}>
                  <RichText
                    tagName="h4"
                    value={address.title}
                    onChange={(value) => updateAddress(index, 'title', value)}
                    placeholder={__('City')}
                  />
                  <RichText
                    tagName="p"
                    value={address.address}
                    onChange={(value) => updateAddress(index, 'address', value)}
                    placeholder={__('Address')}
                  />
                  <Button isDestructive onClick={() => removeAddress(index)}>
                    {__('Remove Address')}
                  </Button>
                </div>
              ))}
              <Button isPrimary onClick={addAddress}>
                {__('Add Address')}
              </Button>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const {
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      addresses,
    } = attributes;

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
        ></div>
        <div className="section-wrapper">
          <div className="offices-list">
            {addresses.map((address, index) => (
              <div className="address-card" key={index}>
                <RichText.Content tagName="h4" value={address.title} />
                <RichText.Content tagName="p" value={address.address} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  },
});
